import { Link } from "react-router-dom";
import { Handshake, LogIn, UserPlus } from "lucide-react";

export default function ClubeLanding() {
  return (
    <div className="min-h-screen bg-navy flex flex-col" data-testid="clube-landing">
      <div className="flex-1 flex flex-col items-center justify-center px-6 py-10">
        <img src="/logo.jpg" alt="Carlos Jr Fretes e Mudanças" className="h-20 w-auto object-contain rounded-xl bg-white p-1.5 mb-6" />
        <div className="w-14 h-14 rounded-2xl bg-[#F5B301] flex items-center justify-center mb-4">
          <Handshake className="w-7 h-7 text-navy" />
        </div>
        <h1 className="font-heading text-2xl font-bold text-white text-center">CLUBE DE INDICADORES</h1>
        <p className="text-sm text-slate-300 text-center mt-3 max-w-xs leading-relaxed" data-testid="clube-descricao">
          Indique clientes para a Carlos Júnior Fretes e Mudanças, acompanhe seus resultados e receba comissões por serviços elegíveis concluídos e pagos.
        </p>
        <div className="w-full max-w-xs mt-8 space-y-3">
          <Link
            to="/clube/cadastro"
            data-testid="clube-cadastrar-btn"
            className="flex items-center justify-center gap-2 w-full py-4 rounded-2xl bg-[#F5B301] text-navy font-extrabold text-sm active:scale-95 transition-transform"
          >
            <UserPlus className="w-4 h-4" /> QUERO ME CADASTRAR
          </Link>
          <Link
            to="/clube/login"
            data-testid="clube-entrar-btn"
            className="flex items-center justify-center gap-2 w-full py-4 rounded-2xl border-2 border-white/30 text-white font-extrabold text-sm active:scale-95 transition-transform"
          >
            <LogIn className="w-4 h-4" /> JÁ SOU INDICADOR — ENTRAR
          </Link>
        </div>
        <p className="text-[11px] text-slate-400 text-center mt-6 max-w-xs">
          Comissões exclusivas para indicações de fretes e mudanças concluídos e pagos.
        </p>
      </div>
      <div className="pb-6 text-center">
        <Link to="/" className="text-xs text-slate-400 underline" data-testid="clube-voltar-home">Voltar ao início</Link>
      </div>
    </div>
  );
}
